<script>
/* eslint-disable */
import {useStore} from "vuex";
import {computed, nextTick, onMounted, ref, watch} from "vue";
import {SVG} from "@svgdotjs/svg.js";
import nw_se from "@/assets/img/nw_se.png";
import ne_sw from "@/assets/img/ne_sw.png";
import rotating_arrow from "@/assets/img/rotate.png";
import remove from "@/assets/img/remove.png";
import valign from "@/assets/img/align_v.png";
import halign from "@/assets/img/align_h.png";
import {calculateSignedAngle, generateImagePath} from "@/components/Sticker-mode/utils";
import {HTTP} from "@/config/api";

export default {
    emits: ['is-back-paper-upload'],
    props: {
        showToolbarCanvas: Function,
        labelOffset: Number,
        isBackPaperUpload: {
            type: Boolean,
            required: true
        }
    },
    setup(props, ctx) {
        const store = useStore();
        const preSelected = ref(JSON.parse(JSON.stringify(store.getters['selection/getPreselected'])));
        const reactiveSelectedMaterial = computed(() => store.getters['selection/getSelectedMaterial']);
        const reactiveSelectedSize = computed(() => store.getters['selection/getSelectedSize']);
        const svgViewPath = computed(() => store.getters["stickerPaper/getSvgViewPath"]);
        const viewPortWidth = computed(() => store.getters["stickerPaper/getViewPortWidth"]);
        const viewPortHeight = computed(() => store.getters["stickerPaper/getViewPortHeight"]);
        const viewBoxWidth = computed(() => store.getters["stickerPaper/getViewBoxWidth"]);
        const viewBoxHeight = computed(() => store.getters["stickerPaper/getViewBoxHeight"]);
        const patternSize = computed(() => store.getters["stickerPaper/getPatternSize"]);

        const drawBackpaper = ref(null);
        const defsBackpaper = ref(null);
        const patternBackpaper = ref(null);
        const preBottomLayerGroupBackpaper = ref(null);
        const svgSheetGroup = ref(null);
        const containerGroup = ref(null);
        const partGroupClipPath = ref(null);
        const containerChildGroup = ref(null);
        const editorBackgroundPath = ref(null);
        const selectLayerGroup = ref(null);
        const hoverRect = ref(null);
        const infoLayerGroup = ref(null);
        const infoTextHorizontal = ref(null);
        const infoTextVertical = ref(null);
        const selectGroup = ref(null);
        const svgElementBackpaper = ref();
        const selectedImage = ref(preSelected.value.selectedMaterial.image);
        const selectButtonIds = ref([]);
        const activeElement = ref(null);
        const selectedTextElement = ref({});
        const isResizing = ref(false);
        const currentResizer = ref(null);

        const defaultColors = computed(() => store.getters["stickerPaper/getBackgroundColors"]);
        const backgroundColor = ref(defaultColors.value[0]);
        const cutlines = ref(store.getters['stickerPaper/getCutlines']);
        const shapeData = ref({});

        onMounted(async () => {
            nextTick(() => {
                initArtboard();
            })
        });

        watch(
            [reactiveSelectedMaterial, reactiveSelectedSize],
            ([newSelectedMaterial, newSelectedSize]) => {
                preSelected.value.selectedMaterial = newSelectedMaterial;
                preSelected.value.selectedSize = newSelectedSize;
                selectedImage.value = preSelected.value.selectedMaterial.image;
            }
        );

        /*watch([svgViewPath], ([newPath]) => {
            if (newPath) {
                svgSheetGroup.value.attr({
                    d: newPath
                });
                editorBackgroundPath.value.attr({
                    d: newPath
                });
            }
        })*/

        watch({
            selectedImage: (newImage) => {
                const patternImage = svgElementBackpaper.value.querySelector('pattern image');
                if (patternImage) {
                    patternImage.setAttribute('href', newImage);
                }
            },
            backgroundColor: (newColor) => {
                const rectElement = svgElementBackpaper.value.querySelector('#backgroundPatternBackpaper rect');
                if (rectElement) {
                    rectElement.setAttribute('fill', newColor);
                }
            },
            /*backgroundColor: (newColor) => {
                const patternRect = svgElementBackpaper.value.querySelector('pattern rect');
                if (patternRect) {
                    patternRect.setAttribute('fill', newColor);
                }
            },*/
        });

        const updateSelectedShape = (shapePath) => {
            svgSheetGroup.value.attr({
                d: shapePath
            });
            editorBackgroundPath.value.attr({
                d: shapePath
            });
            shapeData.value = editorBackgroundPath.value.bbox();
        }

        const getPathDimensions = (d) => {
            const draw = SVG().size(0, 0).hide();
            const path = draw.path(d);
            const bbox = path.bbox();
            draw.remove();
            return {
                x: bbox.x,
                y: bbox.y,
                width: bbox.width,
                height: bbox.height,
            };
        }

        const initArtboard = () => {
            drawBackpaper.value = SVG(svgElementBackpaper.value).attr({
                'size': `${viewPortWidth.value}, ${viewPortHeight.value}`,
                'viewBox': `-400 -100 ${viewBoxWidth.value} ${viewBoxHeight.value}`,
                'preserveAspectRatio': 'xMidYMid meet',
                'fill': '#e7e7e7',
                'align': "center"
            });

            defsBackpaper.value = drawBackpaper.value.defs();
            patternBackpaper.value = defsBackpaper.value.findOne('#backgroundPatternBackpaper');
            patternBackpaper.value.find('rect').attr({ fill: backgroundColor.value });
            preBottomLayerGroupBackpaper.value = drawBackpaper.value.group().id('preBottomLayerBackpaper');
            svgSheetGroup.value = drawBackpaper.value.path(svgViewPath.value).attr({
                transform: 'matrix(1 0 0 1 0 0)',
                class: 'svgSheet single',
                style: 'fill: none;stroke:none'
            });
            containerGroup.value = drawBackpaper.value.group().id('containerBackpaper').attr({
                transform: 'matrix(1 0 0 1 0 0)',
            });

            /* ================================================== */
            /*               Editor Background Layer              */
            /* ================================================== */
            editorBackgroundPath.value = containerGroup.value.path(svgViewPath.value).id('editorBackgroundBackpaper').fill(patternBackpaper.value);
            editorBackgroundPath.value.attr({
                filter: 'url(#drop_shadow)',
                strokeWidth: 0.25,
                stroke: "#dedede"
            });

            /* ================================================== */
            /*               Container Element Group              */
            /* ================================================== */
            partGroupClipPath.value = defsBackpaper.value.findOne('#partGroupClipPathBackpaper');
            containerChildGroup.value = containerGroup.value.group().id('containerChildGroupBackpaper');
            containerChildGroup.value.clipWith(partGroupClipPath.value);

            /*editorBackgroundPath.value.on('click', () => {
                addResizeHandlers(editorBackgroundPath.value);
            });*/

            //addHoverEffectHandler(editorBackgroundPath.value);

            /* ================================================== */
            /*             Dimension Information Layer            */
            /* ================================================== */
            /*infoLayerGroup.value = drawBackpaper.value.group().id('infoLayerBackpaper').attr({ 'transform': 'matrix(1 0 0 1 0 0)' });
            let editorPathBox = editorBackgroundPath.value.bbox();
            infoTextHorizontal.value = infoLayerGroup.value.text(`${preSelected.value.selectedSize.width}"`).id('infoText1Backpaper').x(editorPathBox.x + (editorPathBox.width / 2)).y(editorPathBox.y - props.labelOffset).attr({
                'fill': '#858585',
                'font-weight': 'bold',
                'space': 'preserve',
                'font-size': "14",
                'text-anchor': "middle",
                'transform': "matrix(1 0 0 1 0 0)"
            });
            infoTextVertical.value = infoLayerGroup.value.text(`${preSelected.value.selectedSize.height}"`).id('infoText2Backpaper').x(editorPathBox.x + editorPathBox.width + props.labelOffset).y(editorPathBox.y + (editorPathBox.height / 2)).attr({
                'fill': '#858585',
                'font-weight': 'bold',
                'space': 'preserve',
                'font-size': "14",
                'text-anchor': "middle",
                'transform': "matrix(1 0 0 1 0 0)"
            });*/

            /* ================================================== */
            /*               Element Selection Layer              */
            /* ================================================== */
            selectLayerGroup.value = drawBackpaper.value.group().id('selectLayerGroupBackpaper');
            selectGroup.value = selectLayerGroup.value.group().id('selectGroupBackpaper').attr({
                transform: 'matrix(1 0 0 1 0 0)',
                style: 'display: none;',
            });

            // Event listener to hide selectGroup when clicking outside
            drawBackpaper.value.on('mousedown', (e) => {
                if (selectButtonIds.value.indexOf(e.target.id) === -1) {
                    selectButtonIds.value = [];
                    selectGroup.value.hide();
                }
            });
        };

        const addDragIcon = (position, boundingBox, element) => {
            let {x: posX, y: posY, width: boxWidth, height: boxHeight} = boundingBox;
            const idPrefix = `select${position}Icon`;
            let icon;
            icon = selectGroup.value.group().id(idPrefix).attr({
                class: `svgSelectToolBackpaper svgSelect${position} ${position}`,
                'pointer-events': 'all',
            });

            // Calculate the position based on viewBox coordinates
            posX = posX - 10;
            posY = posY - 10;
            const iconSize = 20;
            let x = 0, y = 0;
            let cursor = '';
            let toolbarIcon = '';
            switch (position) {
                case 'NW': { x = posX; y = posY; cursor = 'nw-resize'; toolbarIcon = nw_se; break; }
                case 'NE': { x = posX + boxWidth; y = posY; cursor = 'ne-resize'; toolbarIcon = ne_sw; break; }
                case 'SE': { x = posX + boxWidth; y = posY + boxHeight; cursor = 'se-resize'; toolbarIcon = nw_se; break; }
                case 'SW': { x = posX; y = posY + boxHeight; cursor = 'sw-resize'; toolbarIcon = ne_sw; break; }
                case 'N': { x = (((posX + boxWidth) + posX) / 2); y = posY - 15; cursor = 'e-resize'; toolbarIcon = rotating_arrow; break; } // rotation button
                case 'X': { x = posX + boxWidth + 25; y = posY; cursor = 'pointer'; toolbarIcon = remove; break; } // remove button
                case 'VA': { x = posX + boxWidth + 25; y = posY + 25; cursor = 'pointer'; toolbarIcon = valign; break; } // remove button
                case 'HA': { x = posX + boxWidth + 25; y = posY + 50; cursor = 'pointer'; toolbarIcon = halign; break; } // remove button
                /*case 'S': { x = (((posX + boxWidth) + posX) / 2); y = posY + boxHeight; cursor = 's-resize'; dragIcon = ns; break; }*/
                /* case 'E': { x = 390; y = 195; cursor = 'e-resize'; dragIcon = ew; break; }
                case 'W': { x = -10; y = 195; cursor = 'w-resize'; dragIcon = ew; break; } */
            }
            icon.attr({
                fill: '#2a2a2a',
                cursor: cursor,
                transform: `translate(${x}, ${y})`,
            });

            // Create the clip path
            /*const clipPath = defsBackpaper.value.clip().id(`${idPrefix}IconClipPath`);
            clipPath.add(drawBackpaper.value.rect(iconSize, iconSize));*/

            // Apply the clip path to the icon
            icon.rect(iconSize, iconSize).attr({
                fill: '#575757',
                rx: 5,
                ry: 5,
                class: 'svgIcon',
                id: `${idPrefix}IconBackground`,
                'pointer-events': 'all',
                //'clip-path': `url(#${idPrefix}IconClipPath)`
            });
            selectButtonIds.value.push(`${idPrefix}IconBackground`);

            const iconSecondGroup = icon.group().attr({
                'pointer-events': 'none',
                //'clip-path': `url(#${idPrefix}IconClipPath)`,
                transform: 'matrix(1 0 0 1 0 0)',
            });

            iconSecondGroup.image(toolbarIcon).attr({
                transform: 'matrix(1 0 0 1 0 0)',
                x: 2,
                y: 2,
                width: 16,
                height: 16,
                id: `${idPrefix}IconImage`,
            });

            // Add resize functionality
            let resizingBox;
            let preX;
            let preY;

            if (position === 'X') {
                icon.on('mousedown', (e) => {
                    e.stopPropagation();
                    removeArtboardElement(element);
                })
            } else if (position === 'VA') {
                icon.on('mousedown', (e) => {
                    e.stopPropagation();
                    let box = svgSheetGroup.value.bbox();
                    element.cy(box.cy);
                    addResizeHandlers(element);
                })
            } else if (position === 'HA') {
                icon.on('mousedown', (e) => {
                    e.stopPropagation();
                    let box = svgSheetGroup.value.bbox();
                    element.cx(box.cx);
                    addResizeHandlers(element);
                })
            } else if (position === 'N') {
                let initAngle = 0;
                let newAngle  = 0;
                let initX;
                let initY;
                icon.draggable()
                    .on('dragstart', (event) => {
                        const { box } = event.detail;
                        currentResizer.value = event.target;
                        resizingBox = element.bbox();
                        initX = box.x;
                        initY = box.y;
                    })
                    .on('dragmove', (event) => {
                        const { box } = event.detail;

                        newAngle  = calculateSignedAngle(initX, initY, box.x, box.y, resizingBox.cx, resizingBox.cy);
                        let deltaAngle = newAngle - initAngle;

                        // Adjust delta angle to be within -180 to 180 degrees
                        if (deltaAngle > 180) {
                            deltaAngle -= 360;
                        } else if (deltaAngle < -180) {
                            deltaAngle += 360;
                        }

                        element.rotate(initAngle + deltaAngle, resizingBox.cx, resizingBox.cy);
                        initAngle = newAngle;
                        initX = box.x;
                        initY = box.y;
                    })
                    .on('dragend', () => {
                        isResizing.value = false;
                        currentResizer.value = null;
                        resizingBox = null;
                        addResizeHandlers(element);
                    });
            } else {
                icon.draggable()
                    .on('dragstart', (event) => {
                        const { box } = event.detail;
                        currentResizer.value = event.target;
                        resizingBox = element.bbox();
                        preX = box.x;
                        preY = box.y;
                        selectGroup.value.hide();
                    })
                    .on('dragmove', (event) => {
                        const { handler, box } = event.detail;
                        let newWidth = box.width;
                        let newHeight = box.height;
                        let newX = preX - box.x;
                        let newY = preY - box.y;
                        if (currentResizer.value.classList.contains('SE')) {
                            isResizing.value = true;
                            newWidth = resizingBox.width - newX;
                            newHeight = resizingBox.height - newY;
                            if (element.type === 'path') {
                                svgSheetGroup.value.size(newWidth, newHeight);
                                infoTextHorizontal.value.x(newWidth / 2);
                                infoTextVertical.value.y(newHeight / 2).x(newWidth + 20);
                            }
                        } else if (currentResizer.value.classList.contains('SW')) {
                            isResizing.value = true;
                            newWidth = resizingBox.width + newX;
                            newHeight = resizingBox.height - newY;
                            element.move(resizingBox.x - newX, resizingBox.y);
                            handler.move(resizingBox.x - newX, resizingBox.y);
                            if (element.type === 'path') {
                                svgSheetGroup.value.size(resizingBox.x - newX, resizingBox.y);
                                infoTextHorizontal.value.x((resizingBox.width - newX) / 2);
                                infoTextVertical.value.x(resizingBox.width + 20).y((resizingBox.height - newY) / 2);
                            }
                        } else if (currentResizer.value.classList.contains('NE')) {
                            isResizing.value = true;
                            newWidth = resizingBox.width - newX;
                            newHeight = resizingBox.height + newY;
                            handler.move(resizingBox.x, resizingBox.y - newY);
                            if (element.type === 'path') {
                                svgSheetGroup.value.size(resizingBox.x, resizingBox.y - newY);
                                infoTextHorizontal.value.x(newWidth / 2).y(resizingBox.y - newY - 30);
                                infoTextVertical.value.y((resizingBox.height - newY) / 2).x(newWidth + 20);
                            }
                        } else if (currentResizer.value.classList.contains('NW')) {
                            isResizing.value = true;
                            newWidth = resizingBox.width + newX;
                            newHeight = resizingBox.height + newY;
                            element.move(resizingBox.x - newX, resizingBox.y - newY);
                            handler.move(resizingBox.x - newX, resizingBox.y - newY);
                            if (element.type === 'path') {
                                svgSheetGroup.value.size(resizingBox.x - newX, resizingBox.y - newY);
                                infoTextHorizontal.value.x(newWidth / 2).y(resizingBox.y - newY - 30);
                                infoTextVertical.value.y((resizingBox.height - newY) / 2).x(newWidth + 20);
                            }
                        }

                        let elementBox = element.bbox();
                        if (isResizing.value) {
                            if (element.type === 'path') {
                                element.size(newWidth, newHeight);
                                editorBackgroundPath.value.size(newWidth, newHeight);
                                let viewPath = editorBackgroundPath.value.attr('d');
                                svgSheetGroup.value.attr({d: viewPath});
                                svgViewPath.value = viewPath;
                            } else if (element.type === 'text') {
                                const scaleFactor = newHeight / elementBox.height;
                                let fontSize = element.font('data-font-size');
                                element.font('size', Math.ceil(fontSize * scaleFactor *.95));
                                element.attr({
                                    'data-font-size': Math.ceil(fontSize * scaleFactor *.95)
                                });
                            } else {
                                element.size(newWidth, newHeight);
                            }
                        }
                    })
                    .on('dragend', (event) => {
                        isResizing.value = false;
                        currentResizer.value = null;
                        resizingBox = null;
                        const { box } = event.detail;
                        addResizeHandlers(element);
                    });
            }
        };

        const updateShape = (shape) => {
            const path = cutLine[shape];
            store.dispatch("stickerPaper/setSvgViewPath", path);
            svgSheetGroup.value.path(path);
            editorBackgroundPath.value.path(path);
        }

        const updateBackgroundImage = (imagePath) => {
            selectedImage.value = imagePath;
            updatePatternImage();
        };

        const updatePatternImage = (imagePath) => {
            drawBackpaper.value.find('#backgroundPatternBackpaper image').attr('href', imagePath);
        };

        /*const updateBackgroundColor = (color) => {
            backgroundColor.value = color;
            drawBackpaper.value.findOne('#backgroundPatternBackpaper rect').attr('fill', color);
        };*/

        const updateBackgroundColor = (color) => {
            backgroundColor.value = color;
            const rectElement = svgElementBackpaper.value.querySelector('#backgroundPatternBackpaper rect');
            if (rectElement) {
                rectElement.setAttribute('fill', color);
            }
        };

        const saveText = (data, updatedTextId = null) => {
            let textId;
            if (updatedTextId) {
                let textElement = SVG(`#${updatedTextId} text`);
                if (textElement) {
                    textElement.text(data.text);
                    textElement.attr({
                        'font-family': data.style.font.font,
                        // 'font-size': '24px',
                        'text-align': data.style.alignment,
                        fill: data.style.color,
                        'data-font-id': data.style.font.id,
                        'data-font-font': data.style.font.font,
                        'data-font-text': data.style.font.text
                    });
                    addResizeHandlers(textElement);

                    const payload = {
                        ...data,
                        id: updatedTextId,
                        type: 'text'
                    };
                    store.dispatch('sticker/updateLayerBackpaper', payload);
                }
                selectedTextElement.value = {};
                return;
            }

            textId = `text_${Date.now()}`;
            let containerTextPart = containerChildGroup.value.group().id(textId).attr({
                class: 'svgElementPartBackpaper',
                transform: 'matrix(1 0 0 1 0 0)',
                'clip-path': 'none'
            });
            const text = containerTextPart.text(data.text).x(200).y(200).attr({
                'font-family': data.style.font.font,
                'font-size': '24px',
                'text-align': data.style.alignment,
                fill: data.style.color,
                'data-font-id': data.style.font.id,
                'data-font-font': data.style.font.font,
                'data-font-text': data.style.font.text,
                'data-font-size': 24,
                //lengthAdjust:"spacingAndGlyphs"
            });

            addHoverEffectHandler(text);

            text.on('click', () => {
                addResizeHandlers(text);
                props.showToolbarCanvas('stickerModelTools', 2);
                data.text = text.text();
                store.dispatch("stickerPaper/setSelectedTextElement", {
                    containerTextPart: containerTextPart,
                    text: text,
                    textId: textId,
                    data: data
                });
            });

            addElementDragHandler(text);

            store.dispatch('sticker/addLayerBackpaper', {
                ...data,
                id: textId,
                type: 'text'
            });
        };

        const addClipart = async (clipart) => {
            let clipart_Id = `clipart_${Date.now()}`;
            let containerClipartPart = containerChildGroup.value.group().id(clipart_Id).attr({
                class: 'svgElementPartBackpaper',
                transform: 'matrix(1 0 0 1 0 0)',
                'clip-path': 'none'
            });
            const clipArtElement = containerClipartPart.image(clipart.thumbnail);
            clipArtElement.size(100, 100).attr({ x: 0, y: 0 });

            addHoverEffectHandler(clipArtElement);

            clipArtElement.on('click', () => {
                addResizeHandlers(clipArtElement);
            });

            addElementDragHandler(clipArtElement);

            await store.dispatch('sticker/addLayerBackpaper', {
                ...clipart,
                id: clipart_Id,
                type: 'clipart'
            });
        };

        const addImage = () => {
            let input = document.createElement('input');
            input.type = 'file';
            input.onchange = async () => {
                let files = Array.from(input.files);
                if (!files || !files.length) return;

                const form = new FormData();
                form.append('file', files[0]);

                ctx.emit('is-back-paper-upload', true);

                const response = await HTTP.post('api/v1/files/store', form);
                const data = response.data;

                let imageId = data.file;
                let containerImagePart = containerChildGroup.value.group().id(imageId).attr({
                    class: 'svgElementPartBackpaper',
                    transform: 'matrix(1 0 0 1 0 0)',
                    'clip-path': 'none'
                });

                const imgElement = containerImagePart.image(data.file_path);
                imgElement.size(100, 100).attr({ x: 0, y: 0 });

                ctx.emit('is-back-paper-upload', false);

                addHoverEffectHandler(imgElement);

                imgElement.on('click', () => {
                    addResizeHandlers(imgElement);
                });

                addElementDragHandler(imgElement);

                previewImages(imageId, data.file_path);

                store.dispatch('sticker/addLayerBackpaper', {
                    id: imageId,
                    type: 'image',
                    img: data.file_path
                });
            };
            input.click();
        };

        const previewImages = (imageId, file) => {
            store.dispatch('sticker/addImagePreviewsBackpaper', {
                id: imageId,
                img: file
            });
        };

        const disableHoverOnDrag = () => {
            if (hoverRect.value) {
                hoverRect.value.remove();
                hoverRect.value = null;
            }
        }

        const addHoverEffectHandler = (element) => {
            // Add event listeners to the background container
            element.on('mouseover', () => {
                if (!hoverRect.value) {
                    const editorBackgroundPathValue = generateImagePath(element);
                    hoverRect.value = selectLayerGroup.value
                        .path(editorBackgroundPathValue)
                        //.path("M 0 21.6851 C -1.46668e-15 9.70874 9.70874 2.20002e-15 21.6851 0 C 21.6851 0 122.882 0 122.882 0 C 134.858 7.33339e-16 144.567 9.70874 144.567 21.6851 C 144.567 21.6851 144.567 122.882 144.567 122.882 C 144.567 134.858 134.858 144.567 122.882 144.567 C 122.882 144.567 21.6851 144.567 21.6851 144.567 C 9.70874 144.567 1.46668e-15 134.858 0 122.882 C 0 122.882 0 21.6851 0 21.6851")
                        .stroke({color: '#575757', width: 1})
                        .fill('none');
                    //.move(225, 75);
                }
            });

            element.on('mouseout', () => {
                if (hoverRect.value) {
                    hoverRect.value.remove();
                    hoverRect.value = null;
                }
            });
        }

        const addResizeHandlers = (element) => {
            const boundingBox = element.type === 'path' ?  element.bbox() : element.parent().bbox();
            selectGroup.value.clear();
            selectGroup.value.rect(boundingBox.width, boundingBox.height).id('selectGroupSelectedMarkerBackpaper').attr({
                x: boundingBox.x,
                y: boundingBox.y,
                width: boundingBox.width,
                height: boundingBox.height,
                fill: 'none',
                stroke: "black",
                strokeWidth: ".2"
            });

            //const sides = ['N', 'E', 'S', 'W'];
            if (element.type !== 'path') {
                const corners = ['NW', 'NE', 'SE', 'SW'];
                corners.forEach(corner => {
                    addDragIcon(corner, boundingBox, element);
                });

                const sides = ['N', 'X', 'VA', 'HA'];
                sides.forEach(side => {
                    addDragIcon(side, boundingBox, element);
                });
            }
            selectGroup.value.show();
        }

        const addElementDragHandler = (element) => {
            const draggable = element.parent().draggable();
            draggable.on('dragmove', e => {
                e.preventDefault();
                selectGroup.value.clear();
                const { handler, box } = e.detail;

                let { x, y, x2, y2 } = box;

                handler.move(x, y);

                if (hoverRect.value) {
                    hoverRect.value.attr({'d': `M${x} ${y} H${x2} V${y2} H${x} Z`});
                }
            });
        }

        const backPaperEdit = computed(() => store.getters["stickerPaper/getBackPaperEdit"]);
        const removeArtboardElement = (element) => {
            const id = element.parent().id();
            element.parent().remove();
            selectGroup.value.clear();
            store.dispatch('sticker/removeLayerBackpaper', id);
            store.dispatch('sticker/removeImagePreviewsBackpaper', id);
        }

        return {
            /* VARIABLES */
            drawBackpaper,
            defsBackpaper,
            patternBackpaper,
            preBottomLayerGroupBackpaper,
            svgSheetGroup,
            containerGroup,
            editorBackgroundPath,
            selectLayerGroup,
            hoverRect,
            infoLayerGroup,
            infoTextHorizontal,
            infoTextVertical,
            selectGroup,
            isResizing,
            currentResizer,
            svgElementBackpaper,
            selectedImage,
            selectButtonIds,
            activeElement,
            selectedTextElement,
            preSelected,
            backgroundColor,
            patternSize,
            svgViewPath,
            cutlines,
            shapeData,

            /* FUNCTIONS */
            initArtboard,
            addDragIcon,
            updateBackgroundImage,
            updatePatternImage,
            updateBackgroundColor,
            saveText,
            addClipart,
            addImage,
            addResizeHandlers,
            addHoverEffectHandler,
            addElementDragHandler,
            disableHoverOnDrag,
            removeArtboardElement,
            updateSelectedShape,
            getPathDimensions
        }
    }
}
</script>
<template>
    <svg id="svgElementBackpaper" ref="svgElementBackpaper" class="user-select-none">
        <defs>
            <pattern id="backgroundPatternBackpaper" patternUnits="userSpaceOnUse" x="0" y="0"
                     :width="patternSize" :height="patternSize">
                <image :href="''" :width="patternSize" :height="patternSize" />
                <rect width="100%" height="100%" :fill="backgroundColor" />
            </pattern>
            <filter id="drop_shadow_backpaper" x="-50%" y="-50%" width="200%" height="200%" filterRes="1920"
                    style="display : inline">
                <feOffset result="offOut" in="SourceAlpha" dx="1.4456715393066406"
                          dy="1.4456715393066406">
                </feOffset>
                <feGaussianBlur result="blurOut" in="offOut" stdDeviation="0.7228357696533203">
                </feGaussianBlur>
                <feColorMatrix result="matrixOut" in="blurOut" type="matrix"
                               values="1 0 0 0 0.2, 0 1 0 0 0.2, 0 0 1 0 0.2, 0 0 0 0.5 0"></feColorMatrix>
                <feBlend in="SourceGraphic" in2="matrixOut" mode="normal"></feBlend>
            </filter>
            <clipPath id="partGroupClipPathBackpaper" transform="matrix(1 0 0 1 0 0)"><path :d="svgViewPath" id="partGroupClipPathBackpaperPath" transform="matrix(1 0 0 1 0 -0.105725)"></path></clipPath>
        </defs>
    </svg>
</template>
